import React, { useState, useRef, useEffect } from 'react';
import { SearchInputProps, SearchInputButtonProps } from './../../../types/search';
import SvgIcon from './../../utils/SvgIcon';

const SearchButton = ({ onSearch, label, hasUnsearchedTerm }: SearchInputButtonProps) => (
  <button
    className={`search__input-button ${hasUnsearchedTerm ? 'search__input-button--unsearched' : ''}`}
    type="button"
    onClick={onSearch}
  >
    <span>{label}</span>
    <SvgIcon iconName="search" className="icon" viewBox="0 0 24 24" />
  </button>
);

const SearchInput = ({
  value,
  label,
  placeholder = 'Search...',
  onChange,
  onSearch,
  isMobile,
  buttonLabel = 'Search',
  hasUnsearchedTerm = false,
  hideButton = false,
}: SearchInputProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const containerClass = `search__input-inner-container${
    isFocused ? ' search__input-inner-container--focused' : ''
  }${hasUnsearchedTerm ? ' search__input-inner-container--unsearched' : ''}`;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <>
      <label className="search__input-label" htmlFor="search-input">
        {label}
      </label>
      <div className={containerClass}>
        <SvgIcon additionalClasses="search__input-left-icon" iconName="search" className="icon" viewBox="0 0 24 24" />
        <input
          ref={inputRef}
          className="search__input"
          id="search-input"
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={e => {
            if (e.key === 'Enter' && onSearch) {
              onSearch();
            }
          }}
        />
        {!isMobile && !hideButton ? (
          <SearchButton onSearch={onSearch} label={buttonLabel} hasUnsearchedTerm={hasUnsearchedTerm} />
        ) : null}
      </div>
      {isMobile && !hideButton ? (
        <SearchButton onSearch={onSearch} label={buttonLabel} hasUnsearchedTerm={hasUnsearchedTerm} />
      ) : null}
    </>
  );
};

export default SearchInput;
